/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import React from "react";
import { Redirect, Switch, Route } from "react-router-dom";
import {Layout} from "./components/layout/Layout";
import BasePage from "./pages/BasePage";
import AuthorizePage from "./pages/auth/AuthorizePage";
import UnauthorizePage from "./pages/auth/UnauthorizedPage"
import EndSessionPage from "./pages/auth/EndSessionPage"
import TokenPage from "./pages/auth/TokenPage";
import LogoutPage from "./pages/auth/LogoutPage";
// import Home from "./pages/DashboardPage";
import { BaseLayoutPage } from "./pages/BaseLayoutPage";
import {IsAuthorized, GetRole} from "../utils/AuthUtils";
import config from "../settings";
import NotFound from './pages/NotFound';

export function Routes() {
    return (
        <Switch>

            <Route path="/logout" component={LogoutPage}/>
            <Route exact path="/unauthorized" component={UnauthorizePage}/>
            <Route exact path="/endsession" component={EndSessionPage}/>
                           
            {/* {window.location.search.substr(1,3)==="pip" ? ( <Route>
                    <TokenPage /> 
                </Route>):(null)} */}

            {/* {window.location.pathname === config.loginCallbackUrl ? ( */}
            {window.location.search.substr(1,5) === config.loginCallbackUrl ? (
                //  <Route>
                //      <TokenPage /> 
                //  </Route>
                <Route component={TokenPage}/>
            ) : !IsAuthorized() ? (
                /*Render auth page when user at `/auth` and not authorized.*/
                <Route>
                    <AuthorizePage />
                </Route>
            ) : (
                /*Otherwise redirect to root page (`/`)*/
                <Redirect from="/authorization" to={window.sessionStorage.getItem("ingressPath") || "/"}/>
            )
            }

            {!IsAuthorized() ? (
                /*Redirect to `/auth` when user is not authorized*/
                <Redirect to="/authorization/login"/>
            ) : (
                (!GetRole()) ? 
                /* unauthorized */
                (<></>) : 
                (<Layout>
                    <BasePage/>
                </Layout>)
            )}

           <Route component={NotFound} />                 
            
        </Switch>
    );
}
